import * as React from 'react';

import { RoomViewModel } from 'models';

import { UitkCardContent } from 'uitk-react-cards';
import { UitkFigure, UitkImage } from 'uitk-react-images';

import { RoomDetails } from './room-details';
import { RoomDetailsRateOptionsWrapper } from './room-details-rate-options-wrapper';
import { RoomPhotos } from 'components/infosite/rooms-and-rates/room-photos';

export interface RatePlanGridViewProps {
  isDateless?: boolean;
  hasPhotos?: boolean;
  room?: RoomViewModel;
  position?: any;
  roomNameClass?: string;
  name?: any;
  hideRoomTitleToA11y?: boolean;
}

export const RatePlanGridView: React.FC<RatePlanGridViewProps> = ({
  isDateless,
  hasPhotos,
  room,
  position,
  roomNameClass,
  name,
  hideRoomTitleToA11y,
}: RatePlanGridViewProps) => (
  <>
    <section className="uitk-grid">
      <UitkCardContent>
        {!isDateless && (
          <>
            {!hasPhotos && (
              <section className="placeholder_image all-cell-1-3 all-x-padding-three all-y-padding-three uitk-cell">
                <UitkFigure className="room__media">
                  <UitkImage alt="" placeholderImage={true} />
                </UitkFigure>
              </section>
            )}
            {hasPhotos && (
              <RoomPhotos className="all-cell-1-3 all-x-padding-three all-y-padding-three" room={room} position={position} name={name} />
            )}
          </>
        )}
        <div className={`uitk-cell all-y-padding-three all-cell-2-3 all-r-padding-three`}>
          <RoomDetails
            amenityClasses={'uitk-type-left'}
            dataStid={'content-room-name-with-icon'}
            infoDialogClasses={roomNameClass}
            position={position}
            room={room}
            hideRoomTitleToA11y={hideRoomTitleToA11y}
          />
        </div>
      </UitkCardContent>
    </section>
    {(!room.unavailableRatePlans || room.unavailableRatePlans.length === 0) && (
      <RoomDetailsRateOptionsWrapper position={position} room={room} />
    )}
  </>
);
